module.exports = __webpack_public_path__ + "static/media/sd2.57cd0fbb.png";